import {ActionTree, GetterTree, Module, MutationTree} from 'vuex';
import {RootState} from '../RootState';
import {settings} from '@/plugins/settings';
import {helpdeskAxios} from '@/plugins/helpdeskAxios';
import responseHandler from '@/plugins/errorHandling';

export interface ISpamSender {
  id: number;
  value: string;
  created_at: string;
  updated_at: string;
}

interface SpamState {
  senders: ISpamSender[];
  currentPage: number;
  lastPage: number;
  total: number;
  perPage: number;
  errors: any;
}

const state: SpamState = {
  senders: [],
  currentPage: 1,
  lastPage: 1,
  total: 0,
  perPage: 15,
  errors: {},
};

const getters: GetterTree<SpamState, RootState> = {
  senders:     (state) => state.senders,
  currentPage: (state) => state.currentPage,
  lastPage:    (state) => state.lastPage,
  total:       (state) => state.total,
  perPage:     (state) => state.perPage,
};

const mutations: MutationTree<SpamState> = {
  errors(state, payload: any) { state.errors = payload; },
  spamSendersLoaded(state, payload: any) {
    state.senders     = payload.data;
    state.currentPage = payload.current_page;
    state.lastPage    = payload.last_page;
    state.total       = payload.total;
    state.perPage     = payload.per_page;
  },
  spamSenderCreated(_state, _payload: any) {},
  spamSenderDeleted(_state, _payload: any) {},
};

const actions: ActionTree<SpamState, RootState> = {
  fetchSenders: ({commit}, params: {page?: number; per_page?: number; search?: string} | undefined) => {
    const query = new URLSearchParams();
    if (params && params.page)     query.set('page',     String(params.page));
    if (params && params.per_page) query.set('per_page', String(params.per_page));
    if (params && params.search)   query.set('search',   params.search);
    const qs = query.toString() ? '?' + query.toString() : '';
    return responseHandler.handle(
      () => helpdeskAxios({url: settings.helpdeskEndpoint + 'v1/spam' + qs, method: 'GET'}),
      commit, 'spamSendersLoaded',
    );
  },
  createSender: ({commit}, value: string) => responseHandler.handle(
    () => helpdeskAxios({url: settings.helpdeskEndpoint + 'v1/spam', method: 'POST', data: {value}}),
    commit, 'spamSenderCreated', null, false,
  ),
  deleteSender: ({commit}, id: number) => responseHandler.handle(
    () => helpdeskAxios({url: settings.helpdeskEndpoint + 'v1/spam/' + id, method: 'DELETE'}),
    commit, 'spamSenderDeleted', null, false,
  ),
};

export const helpdeskSpamModule: Module<SpamState, RootState> = {
  namespaced: true, state, getters, mutations, actions,
};
